import React, { useContext , useEffect, useRef, useState } from "react";
import styles from './Catalogue.module.css';
import generalStyles from '../generalAssets/GeneralAssets.module.css';
import buttonStyles from '../../buttons/Buttons.module.css';
import { BrandCountryContext } from "../../providers/BrandCountryProvider";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { QuoteBasketContext } from "../../providers/QuoteBasketProvider";
import ProductCardV3 from "./ProductCardV3";
import { displayCommas, numberTo2sf } from "../../../functions/NumericalFunctions";
import HiQQuoteNavigation from "../../tabNavigation/HiQQuoteNavigation";
import { LoggedInContext } from "../../providers/LoggedInContext";
import { getTimeStamp } from "../../../functions/DateFunctions";
import SubmitRequestCard from "./SubmitRequestCard";
import { sortAlphaNumeric } from "../../../functions/SortFunctions";

export default function SubmittedRequests(){

    const { user , backendEndpoint } = useContext(LoggedInContext);
    const { setDisable , handlePageChange } = useContext(BrandCountryContext);
    const { basketArray , detailsObject , setDetailsObject } = useContext(QuoteBasketContext);

    const navigate = useNavigate();

    const [quoteRequests,setQuoteRequests] = useState([]);
    const [quoteRequestItems,setQuoteRequestItems] = useState([]);

    useEffect(() => {
        handlePageChange(window.location.pathname);
        getRequests(user.id);
    },[]);

    const getRequests = (userId) => {
        const headers = new Headers();
        headers.append('Content-Type','application/x-www-form-urlencoded');
        fetch(backendEndpoint+'/submit/'+userId,{
            method: 'GET',
            headers: headers,
            credentials: 'include',
        })
        .then((res) => res.text())
        .then((data) => {
            const recObj = JSON.parse(data);
            console.log(recObj);
            setQuoteRequests(recObj.quoteRequests.quoteRequests);
            setQuoteRequestItems(recObj.quoteRequests.quoteRequestItems);
        })
        .catch((err) => console.log(err));
    }
    
    return(
        <div className={generalStyles.container} >
            <div className={styles.mobileCon}>
                <h2>Your Latest Submitted Requests</h2>
                {quoteRequests.length > 0? quoteRequests.sort(sortAlphaNumeric('createdAt',"desc","date")).map((request,index) => <div className={styles.outerCard}><SubmitRequestCard request={request} items={quoteRequestItems}/><hr style={{display: `${quoteRequests.length - 1 === index? 'block' : 'block'}`}}/></div>) : ''}
            </div>
        </div>
    )
}